import { NgModule, ModuleWithProviders } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconService, IconConfig } from './services/icon.service';
import { NMFTAIconComponent } from '@shared/components/atoms/icon/icon.component';

@NgModule({
  imports: [MatIconModule, NMFTAIconComponent],
  exports: [MatIconModule, NMFTAIconComponent]
})
export class NMFTAIconModule {
  constructor(private iconService: IconService) {
    this.iconService.configIcons();
  }

  static forRoot(config: IconConfig): ModuleWithProviders<NMFTAIconModule> {
    return {
      ngModule: NMFTAIconModule,
      providers: [
        { provide: 'ICON_CONFIG', useValue: config },
        IconService
      ]
    };
  }
}
